import React from "react";

const baseScatter = [
  { kind: "dot", x: 12, y: 12, radius: 0.6, color: "#c084fc", opacity: 0.55 },
  { kind: "dot", x: 22, y: 24, radius: 0.55, color: "#f97316", opacity: 0.6 },
  { kind: "dot", x: 38, y: 10, radius: 0.5, color: "#f472b6", opacity: 0.55 },
  { kind: "dot", x: 54, y: 22, radius: 0.6, color: "#a855f7", opacity: 0.6 },
  { kind: "dot", x: 70, y: 8, radius: 0.6, color: "#ec4899", opacity: 0.6 },
  { kind: "dot", x: 86, y: 16, radius: 0.55, color: "#facc15", opacity: 0.6 },
  { kind: "dot", x: 14, y: 44, radius: 0.5, color: "#f472b6", opacity: 0.5 },
  { kind: "dot", x: 30, y: 34, radius: 0.55, color: "#fb7185", opacity: 0.55 },
  { kind: "dot", x: 48, y: 46, radius: 0.55, color: "#fbbf24", opacity: 0.55 },
  { kind: "dot", x: 66, y: 38, radius: 0.52, color: "#f97316", opacity: 0.55 },
  { kind: "dot", x: 84, y: 44, radius: 0.5, color: "#c026d3", opacity: 0.55 },
  { kind: "dot", x: 20, y: 72, radius: 0.55, color: "#ec4899", opacity: 0.55 },
  { kind: "dot", x: 40, y: 84, radius: 0.5, color: "#a855f7", opacity: 0.52 },
  { kind: "dot", x: 60, y: 74, radius: 0.55, color: "#fb7185", opacity: 0.5 },
  { kind: "dot", x: 78, y: 82, radius: 0.52, color: "#facc15", opacity: 0.52 },
  { kind: "dot", x: 92, y: 70, radius: 0.5, color: "#f472b6", opacity: 0.5 },
  { kind: "ring", x: 16, y: 16, radius: 1.3, stroke: "#a855f7", strokeWidth: 0.35, opacity: 0.68 },
  { kind: "ring", x: 44, y: 28, radius: 1.1, stroke: "#fbbf24", strokeWidth: 0.32, opacity: 0.6 },
  { kind: "ring", x: 70, y: 20, radius: 1.2, stroke: "#ec4899", strokeWidth: 0.35, opacity: 0.62 },
  { kind: "ring", x: 28, y: 60, radius: 1.0, stroke: "#f97316", strokeWidth: 0.32, opacity: 0.58 },
  { kind: "ring", x: 56, y: 64, radius: 1.2, stroke: "#c084fc", strokeWidth: 0.32, opacity: 0.6 },
  { kind: "ring", x: 82, y: 58, radius: 1.1, stroke: "#fb7185", strokeWidth: 0.32, opacity: 0.58 },
  { kind: "diamond", x: 10, y: 26, size: 2.4, color: "#f472b6", opacity: 0.48 },
  { kind: "diamond", x: 34, y: 24, size: 2.0, color: "#f97316", opacity: 0.48 },
  { kind: "diamond", x: 58, y: 32, size: 2.2, color: "#facc15", opacity: 0.48 },
  { kind: "diamond", x: 82, y: 26, size: 2.2, color: "#c084fc", opacity: 0.48 },
  { kind: "diamond", x: 24, y: 86, size: 2.0, color: "#ec4899", opacity: 0.44 },
  { kind: "diamond", x: 74, y: 72, size: 2.4, color: "#fb7185", opacity: 0.44 },
  { kind: "plus", x: 8, y: 64, size: 3.2, strokeWidth: 0.45, color: "#c084fc", opacity: 0.65 },
  { kind: "plus", x: 42, y: 13, size: 3.4, strokeWidth: 0.45, color: "#f916eaff", opacity: 0.65 },
  { kind: "plus", x: 92, y: 34, size: 3.0, strokeWidth: 0.45, color: "#f472b6", opacity: 0.6 },
  { kind: "plus", x: 64, y: 86, size: 3.2, strokeWidth: 0.45, color: "#fbbf24", opacity: 0.6 },
  { kind: "triangle", x: 18, y: 30, size: 4.8, color: "#f97316", opacity: 0.4 },
  { kind: "triangle", x: 54, y: 15, size: 3.8, color: "#f472b6", opacity: 0.42 },
  { kind: "triangle", x: 76, y: 48, size: 4.2, color: "#fbbf24", opacity: 0.4 },
  { kind: "triangle", x: 88, y: 76, size: 4.6, color: "#ec4899", opacity: 0.42 }
];

const pseudoRandom = (seed) => {
  const value = Math.sin(seed * 12.9898) * 43758.5453;
  return value - Math.floor(value);
};

const renderScatter = (shape, index) => {
  shape.y += 12;
  switch (shape.kind) {
    case "dot":
      return (
        <circle
          key={index}
          cx={shape.x}
          cy={shape.y}
          r={shape.radius}
          fill={shape.color}
          opacity={shape.opacity}
        />
      );
    case "ring":
      return (
        <circle
          key={index}
          cx={shape.x}
          cy={shape.y}
          r={shape.radius}
          fill="none"
          stroke={shape.stroke}
          strokeWidth={shape.strokeWidth}
          opacity={shape.opacity}
        />
      );
    case "diamond": {
      const half = shape.size / 2;
      return (
        <rect
          key={index}
          x={shape.x - half}
          y={shape.y - half}
          width={shape.size}
          height={shape.size}
          fill={shape.color}
          opacity={shape.opacity}
          transform={`rotate(${45 + (shape.rotation ?? 0)} ${shape.x} ${shape.y})`}
        />
      );
    }
    case "plus": {
      const half = shape.size / 2;
      return (
        <g
          key={index}
          opacity={shape.opacity}
          transform={`rotate(${shape.rotation ?? 0} ${shape.x} ${shape.y})`}
        >
          <line
            x1={shape.x - half}
            y1={shape.y}
            x2={shape.x + half}
            y2={shape.y}
            stroke={shape.color}
            strokeWidth={shape.strokeWidth}
            strokeLinecap="round"
          />
          <line
            x1={shape.x}
            y1={shape.y - half}
            x2={shape.x}
            y2={shape.y + half}
            stroke={shape.color}
            strokeWidth={shape.strokeWidth}
            strokeLinecap="round"
          />
        </g>
      );
    }
    case "triangle": {
      const half = shape.size / 2;
      const height = (Math.sqrt(3) / 2) * shape.size;
      const points = [
        `${shape.x} ${shape.y - (2 * height) / 3}`,
        `${shape.x - half} ${shape.y + height / 3}`,
        `${shape.x + half} ${shape.y + height / 3}`
      ].join(", ");
      return (
        <polygon
          key={index}
          points={points}
          fill={shape.color}
          opacity={shape.opacity}
          transform={`rotate(${shape.rotation ?? 0} ${shape.x} ${shape.y})`}
        />
      );
    }
    default:
      return null;
  }
};

export default function BackgroundSvg() {
  const scatterShapes = React.useMemo(() => {
    return baseScatter.map((shape, index) => {
      const base = { ...shape };
      const sizeJitter = 0.8 + pseudoRandom(index + 1) * 0.4; // 0.8 - 1.2
      const rotation = pseudoRandom(index + 73) * 360;

      switch (base.kind) {
        case "dot":
          return { ...base, radius: base.radius * sizeJitter };
        case "ring":
          return {
            ...base,
            radius: base.radius * sizeJitter,
            strokeWidth: base.strokeWidth * (0.85 + pseudoRandom(index + 133) * 0.3)
          };
        case "diamond":
          return {
            ...base,
            size: base.size * sizeJitter,
            rotation: 20 + rotation * 0.6 // keep around 20-236 deg in addition to base
          };
        case "plus":
          return {
            ...base,
            size: base.size * sizeJitter,
            rotation
          };
        case "triangle":
          return {
            ...base,
            size: base.size * sizeJitter,
            rotation
          };
        default:
          return base;
      }
    });
  }, []);

  return (
    <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden bg-gradient-to-br from-purple-950 via-slate-950 to-fuchsia-950">
      <svg className="h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid slice">
        <defs>
          <radialGradient id="backlight" cx="50%" cy="20%" r="65%">
            <stop offset="0%" stopColor="#312e81" stopOpacity="0.85" />
            <stop offset="60%" stopColor="#111827" stopOpacity="0.25" />
            <stop offset="100%" stopColor="#020617" stopOpacity="0" />
          </radialGradient>
          <radialGradient id="uplight" cx="70%" cy="80%" r="75%">
            <stop offset="0%" stopColor="#be185d" stopOpacity="0.55" />
            <stop offset="65%" stopColor="#111827" stopOpacity="0.2" />
            <stop offset="100%" stopColor="#020617" stopOpacity="0" />
          </radialGradient>
          <radialGradient id="blueGlow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#38bdf8" stopOpacity="0.65" />
            <stop offset="100%" stopColor="#38bdf8" stopOpacity="0" />
          </radialGradient>
          <radialGradient id="amberGlow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#facc15" stopOpacity="0.55" />
            <stop offset="100%" stopColor="#facc15" stopOpacity="0" />
          </radialGradient>
          <linearGradient id="violetDiamond" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#c084fc" stopOpacity="0.7" />
            <stop offset="100%" stopColor="#6366f1" stopOpacity="0.35" />
          </linearGradient>
          <filter id="blurGlow" x="-150%" y="-150%" width="400%" height="400%">
            <feGaussianBlur stdDeviation="1.15" />
          </filter>
        </defs>

        <rect x="0" y="0" width="100" height="100" fill="url(#backlight)" opacity="0.85" />
        <rect x="0" y="0" width="100" height="100" fill="url(#uplight)" opacity="0.75" />

        <g opacity="0.68">{scatterShapes.map(renderScatter)}</g>

        <g filter="url(#blurGlow)">
          <circle cx="18" cy="90" r="9" fill="url(#blueGlow)" opacity="0.45">
            <animateTransform attributeName="transform" type="translate" values="0 0; 0 -1.5; 0 0" dur="11s" repeatCount="indefinite" />
          </circle>
          <circle cx="70" cy="40" r="7.5" fill="none" stroke="#38bdf8" strokeWidth="1.1" opacity="0.35">
            <animate attributeName="r" values="6.8;7.5;6.8" dur="12s" repeatCount="indefinite" />
          </circle>
          <rect x="72" y="76" width="10" height="10" fill="url(#violetDiamond)" opacity="0.4" transform="rotate(45 77 69)">
            <animateTransform attributeName="transform" type="rotate" from="45 77 69" to="405 77 69" dur="28s" repeatCount="indefinite" />
          </rect>
          <g transform="translate(25 42)" opacity="0.42">
            <line x1="-6" y1="0" x2="6" y2="0" stroke="#f97316" strokeWidth="1.2" strokeLinecap="round">
              <animateTransform attributeName="transform" type="rotate" from="0" to="360" dur="25s" repeatCount="indefinite" />
            </line>
            <line x1="0" y1="-6" x2="0" y2="6" stroke="#f97316" strokeWidth="1.2" strokeLinecap="round">
              <animateTransform attributeName="transform" type="rotate" from="0" to="-360" dur="25s" repeatCount="indefinite" />
            </line>
          </g>
          <circle cx="86" cy="82" r="6.5" fill="url(#amberGlow)" opacity="0.35">
            <animateTransform attributeName="transform" type="translate" values="0 0; 0 1.8; 0 0" dur="14s" repeatCount="indefinite" />
          </circle>
        </g>

        <g opacity="0.45">
          <circle cx="12" cy="62" r="1.4" fill="#60a5fa">
            <animate attributeName="r" values="0.9;1.4;0.9" dur="6s" repeatCount="indefinite" />
          </circle>
          <circle cx="44" cy="88" r="1.6" stroke="#22d3ee" strokeWidth="0.35" fill="none">
            <animate attributeName="r" values="1;1.6;1" dur="8s" repeatCount="indefinite" />
          </circle>
          <rect x="82" y="34" width="2.2" height="2.2" fill="#c084fc" transform="rotate(45 83.1 35.1)">
            <animateTransform attributeName="transform" type="translate" values="0 0; 0 1.2; 0 0" dur="9s" repeatCount="indefinite" />
          </rect>
        </g>
      </svg>
    </div>
  );
}